// Event types for WineryXplorer
export const EVENT_TYPES = [
    'tasting',
    'harvest',
    'festival',
    'dinner',
    'tour',
    'class',
    'release',
    'celebration',
    'other'
];
export const EVENT_STATUS = [
    'draft',
    'published',
    'cancelled',
    'completed'
];
export const EVENT_AUDIENCE = ['public', 'members_only'];
